/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Gender,
    GenderFromJSON,
    GenderFromJSONTyped,
    GenderToJSON,
} from './Gender';

/**
 * 
 * @export
 * @interface ProgramAttendeeCreateParams
 */
export interface ProgramAttendeeCreateParams {
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendeeCreateParams
     */
    program_id: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendeeCreateParams
     */
    attendee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendeeCreateParams
     */
    primary_contact_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendeeCreateParams
     */
    primary_contact_email?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendeeCreateParams
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendeeCreateParams
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendeeCreateParams
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendeeCreateParams
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendeeCreateParams
     */
    picture_url?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendeeCreateParams
     */
    picture_file_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendeeCreateParams
     */
    date_of_birth?: string;
    /**
     * 
     * @type {Gender}
     * @memberof ProgramAttendeeCreateParams
     */
    gender?: Gender;
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendeeCreateParams
     */
    parent_name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProgramAttendeeCreateParams
     */
    medical_history?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProgramAttendeeCreateParams
     */
    dietary_restrictions?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendeeCreateParams
     */
    health_card_number?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendeeCreateParams
     */
    emergency_contact_phone?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramAttendeeCreateParams
     */
    emergency_contact_email?: string;
    /**
     * 
     * @type {any}
     * @memberof ProgramAttendeeCreateParams
     */
    properties: any;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramAttendeeCreateParams
     */
    send_invite?: boolean;
}

export function ProgramAttendeeCreateParamsFromJSON(json: any): ProgramAttendeeCreateParams {
    return ProgramAttendeeCreateParamsFromJSONTyped(json, false);
}

export function ProgramAttendeeCreateParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramAttendeeCreateParams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'program_id': json['program_id'],
        'attendee_id': !exists(json, 'attendee_id') ? undefined : json['attendee_id'],
        'primary_contact_id': !exists(json, 'primary_contact_id') ? undefined : json['primary_contact_id'],
        'primary_contact_email': !exists(json, 'primary_contact_email') ? undefined : json['primary_contact_email'],
        'first_name': json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'picture_url': !exists(json, 'picture_url') ? undefined : json['picture_url'],
        'picture_file_id': !exists(json, 'picture_file_id') ? undefined : json['picture_file_id'],
        'date_of_birth': !exists(json, 'date_of_birth') ? undefined : json['date_of_birth'],
        'gender': !exists(json, 'gender') ? undefined : GenderFromJSON(json['gender']),
        'parent_name': !exists(json, 'parent_name') ? undefined : json['parent_name'],
        'medical_history': !exists(json, 'medical_history') ? undefined : json['medical_history'],
        'dietary_restrictions': !exists(json, 'dietary_restrictions') ? undefined : json['dietary_restrictions'],
        'health_card_number': !exists(json, 'health_card_number') ? undefined : json['health_card_number'],
        'emergency_contact_phone': !exists(json, 'emergency_contact_phone') ? undefined : json['emergency_contact_phone'],
        'emergency_contact_email': !exists(json, 'emergency_contact_email') ? undefined : json['emergency_contact_email'],
        'properties': json['properties'],
        'send_invite': !exists(json, 'send_invite') ? undefined : json['send_invite'],
    };
}

export function ProgramAttendeeCreateParamsToJSON(value?: ProgramAttendeeCreateParams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'program_id': value.program_id,
        'attendee_id': value.attendee_id,
        'primary_contact_id': value.primary_contact_id,
        'primary_contact_email': value.primary_contact_email,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'email': value.email,
        'phone': value.phone,
        'picture_url': value.picture_url,
        'picture_file_id': value.picture_file_id,
        'date_of_birth': value.date_of_birth,
        'gender': GenderToJSON(value.gender),
        'parent_name': value.parent_name,
        'medical_history': value.medical_history,
        'dietary_restrictions': value.dietary_restrictions,
        'health_card_number': value.health_card_number,
        'emergency_contact_phone': value.emergency_contact_phone,
        'emergency_contact_email': value.emergency_contact_email,
        'properties': value.properties,
        'send_invite': value.send_invite,
    };
}

